export default {
  searchresults: "搜尋結果",
  boxtitle: "你輸入了此搜尋字串",
  fuzzy: '近似搜尋', 
  fuzzy_desc: '使用近似搜尋以查詢含有拼寫錯誤或字眼相近的結果。注意本功能未涵蓋中文搜尋詞。',
  fuzzy_on: '使用中',
  fuzzy_off: '已關閉',
  suggestion: '相關搜尋詞',
  suggestion_desc: '下列為經常並列使用的關鍵字。擊點以增加至你的搜尋中。注意本功能未涵蓋中文搜尋詞。',
  changefilter: '更改搜尋範圍',
  legis_rec: '你是否在尋找 ',
  status: "狀態",
  toadv: "使用進階搜尋以獲得更精確的結果",
  max_reached: "我們只提供了最相關的{0}項結果",
  doc: '文件類別',
  advs: {
    advanced: '進階搜尋',
    advancedshort: '進階搜尋',
    citation: '引述案例編號',
    neutral: '引述案例通用編號',
    legisname: "法例名稱",
    parties: "訴訟各方",
    coram: "審理法官",
    representation: "律師代表",
    charge: "控罪",
    allwords: "包含所有字詞",
    anywords: "包含任何字詞",
    phrase: "包含完整字句",
    help: "搜尋幫助",
    specfield: "輸入指定類別關鍵字",
    allfield: "輸入任何關鍵字",
    date: "篩選文件日期",
    dbs: "篩選資料庫類別",
    selecteddbs: "選擇個別資料庫",
    selected: "已選",
  }
}